import React, { Component } from 'react'
import $ from 'jquery'

import TextInput from '../../../textInput'
import { urlFormat, notEmpty, isValid, justNumber } from '../../../validations'
import moment from 'moment';
import { createSlug } from '../../../utils'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import FileDropZone from '../../fileDropZone'
import { configs } from '../../../helpers/constants'
import { post, postFormData, get } from '../../../utils/networking'
import * as Notify from '../../../notification'
import VirtualizedSelect from 'react-virtualized-select';
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

const validationData = {
    businessName: [notEmpty],
    businessWebsite: [notEmpty, urlFormat],
    businessPhone: [notEmpty, justNumber],
    businessFacebook: [notEmpty, urlFormat],
    businessPinterest: [notEmpty, urlFormat],
    businessTwitter: [notEmpty, urlFormat],
    businessInstagram: [notEmpty, urlFormat],
    businessVideo: [notEmpty, urlFormat],
    photo: [notEmpty],
    zipCode: [notEmpty, justNumber]
}

export default class GeneralSetting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            businessName: "",
            address: '',
            zipCode: 0,
            longtitude: 0,
            latitude: 0,
            businessWebsite: "#",
            businessPhone: "",
            businessFacebook: "#",
            businessPinterest: "#",
            businessTwitter: "#",
            businessInstagram: "#",
            businessVideo: "#",
            businessIntro: "",
            businessAboutUs: "",
            photos: [],
            slug: "",
            content: "",
            intro: "",
            about: "",
            isEditLink: false,
            isLoaded: false,
            countrys: [],
            countryValue: null,
            states: [],
            stateValue: null,
            citys: [],
            cityValue: null,
            addressLoaded: false,
            logo: []
        }
        this.handleSelect = this.handleSelect.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.renderGeocodeFailure = this.renderGeocodeFailure.bind(this)
        this.renderGeocodeSuccess = this.renderGeocodeSuccess.bind(this)
    }
    onTitleChange(value) {
        this.setState({
            businessName: value,
            slug: createSlug(value)
        })
    }
    handleSelect(address) {
        this.setState({
            address,
            loading: true
        })

        geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                this.setState({
                    geocodeResults: this.renderGeocodeSuccess(lat, lng),
                    loading: false
                })
            })
            .catch((error) => {
                this.setState({
                    geocodeResults: this.renderGeocodeFailure(error),
                    loading: false
                })
            })
    }
    handleChange(address) {
        this.setState({
            address,
            geocodeResults: null
        })
    }
    renderGeocodeFailure(err) {
        return (
            <div className="alert alert-danger" role="alert">
                <strong>Error!</strong> {err}
            </div>
        )
    }
    renderGeocodeSuccess(lat, lng) {
        this.setState({
            longtitude: lng,
            latitude: lat
        })
    }

    onAboutUsChange(e) {
        document.getElementById("about_us_validation").textContent = "";
        this.setState({
            businessAboutUs: e.target.value
        })
    }

    onAddPhoto(file) {
        $("#save").html("<i class='fa fa-spinner fa-pulse'></i> Waiting...");
        let { photos } = this.state;
        var data = new FormData()
        data.append("file", file[0])
        postFormData('upload', data, "partner", result => {
            photos.push(result)
            this.setState({
                photos
            })
            $("#save").html("Save");
        })
    }
    onAddLogo(file) {
        const that = this;
        let { logo } = this.state;
        var reader = new FileReader();
        reader.onload = function (e) {
            logo = [];
            logo.push(e.target.result);
            that.setState({
                logo,
                isShowPopup: false
            })
        }
        reader.readAsDataURL(file[0]);
    }
    onRemoveLogo() {
        const that = this;
        that.setState({
            logo: []
        })
    }

    onRemovePhoto(relativePath) {
        let { photos } = this.state

        photos = photos.filter(item => item != relativePath)

        this.setState({
            photos
        })
    }

    handleUpdate() {
        Notify.hide();
        let param = {
            slug: this.state.slug,
            name: this.state.businessName,
            intro: "null",
            about: this.state.businessAboutUs,
            phone: this.state.businessPhone,
            website: this.state.businessWebsite,
            address1: this.state.address,
            address2: this.state.address2,
            city: this.state.cityValue,
            zipCode: this.state.zipCode,
            longtitude: this.state.longtitude,
            latitude: this.state.latitude,
            photos: this.state.photos,
            facebookLink: this.state.businessFacebook,
            pinterestLink: this.state.businessPinterest,
            twitterLink: this.state.businessTwitter,
            instagramLink: this.state.businessInstagram,
            videoLink: this.state.businessVideo,
            logo: this.state.logo[0],
            state: this.state.stateValue,
            country: this.state.countryValue,
            firstName: this.state.firstName,
            lastName: this.state.lastName
        };

        let address = this.state.address + ", " + this.state.address2 + ", " + this.state.city

        let url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address.split(" ").join("%20") + '&key=AIzaSyDk17id-kgU2ZXd_LOq30TEsgsLAY45358';
        fetch(url)
            .then(res => res.json()
                .then((out) => {
                    param.longtitude = (out.results[0]) ? out.results[0].geometry.location.lng : 0;
                    param.latitude = (out.results[0]) ? out.results[0].geometry.location.lat : 0;
                    $("#save").html("<i class='fa fa-spinner fa-pulse'></i> Saving...");
                    post("spa/updateBasicInfo", param, "partner", result => {
                        Notify.show($("#save"), "Update success", "success", "0");
                        $("#save").html("Save");
                    }, errors => {
                        Notify.show($("#save"), errors.errors[0], "fail", "0");
                        $("#save").html("Save");
                    })
                }))
            .catch(err => {
                $("#save").html("<i class='fa fa-spinner fa-pulse'></i> Saving...");
                post("spa/updateBasicInfo", param, "partner", result => {
                    Notify.show($("#save"), "Update success", "success", "0");
                    $("#save").html("Save");
                }, errors => {
                    Notify.show($("#save"), errors.errors[0], "fail", "0");
                    $("#save").html("Save");
                })
            });



    }

    componentDidMount() {
        get("spa/get", "partner",
            result => {
                console.log("result", result)
                this.setState({
                    businessName: result.name,
                    zipCode: result.zipCode,
                    address: result.address1,
                    address2: result.address2,
                    longtitude: result.longtitude,
                    latitude: result.latitude,
                    businessWebsite: result.website,
                    businessPhone: result.phone,
                    businessFacebook: result.facebookLink,
                    businessPinterest: result.pinterestLink,
                    businessTwitter: result.twitterLink,
                    businessInstagram: result.instagramLink,
                    businessVideo: result.videoLink,
                    businessIntro: result.intro,
                    businessAboutUs: result.about,
                    photos: result.photos,
                    slug: createSlug(result.name),
                    cityValue: result.city,
                    logo: [result.logo],
                    isLoaded: true,
                    countryValue: result.country,
                    stateValue: result.state,
                    firstName: result.partner.firstName,
                    lastName: result.partner.lastName
                }, () => {
                    this.getCity(() => {
                        this.getState(() => {
                            this.getCountry(() => {
                                // this.checkAddress();
                                this.setState({
                                    addressLoaded: true
                                })
                            })
                        })
                    })
                })
            })
    }

    checkAddress() {
        var addressArray = this.state.address.split(", ");
        var finalAddress = "", finalCity = "", finalState = "";
        var temtp = this.state.states.filter(e => e.name.toLowerCase() === (this.state.cityValue) ? this.state.cityValue.toLowerCase() : "");
        if (temtp.length > 0) {
            finalAddress = "";
            for (var i = 0; i < addressArray.length - 2; i++) {
                finalAddress += addressArray[i] + ", "
            }
            this.setState({
                countryValue: (addressArray[addressArray.length - 1]) ? addressArray[addressArray.length - 1].trim() : "",
                stateValue: (this.state.city) ? this.state.city.trim() : "",
                address: finalAddress.trim(),
                addressLoaded: true
            })
        } else {
            finalAddress = "";
            for (var i = 0; i < addressArray.length - 3; i++) {
                finalAddress += addressArray[i] + ", "
            }
            this.setState({
                countryValue: (addressArray[addressArray.length - 1]) ? addressArray[addressArray.length - 1].trim() : "",
                stateValue: (addressArray[addressArray.length - 2]) ? addressArray[addressArray.length - 2].trim() : "",
                cityValue: (this.state.city) ? this.state.city.trim() : "",
                address: finalAddress.trim().substr(0, finalAddress.trim().lastIndexOf(',')),
                addressLoaded: true
            })
        }
    }

    getState(callback) {
        get("web/state/", "",
            result => {
                this.setState({
                    states: result
                }, () => callback())
            })
    }

    getCity(callback) {
        get("web/city/", "",
            result => {
                this.setState({
                    citys: result
                }, () => callback())
            })
    }
    getCountry(callback) {
        get("web/country", "",
            result => {
                this.setState({
                    countrys: result
                }, () => callback())
            })
    }

    render() {
        let {
            businessName,
            address,
            address2,
            zipCode,
            longtitude,
            latitude,
            businessWebsite,
            businessPhone,
            businessFacebook,
            businessPinterest,
            businessTwitter,
            businessInstagram,
            businessVideo,
            businessIntro,
            businessAboutUs,
            link,
            photos,
            isEditLink,
            categoryId,
            options,
            synopsis,
            countrys,
            countryValue,
            states,
            stateValue,
            citys,
            cityValue,
            city,
            addressLoaded,
            logo,
            isShowPopup,
            firstName,
            lastName
        } = this.state
        const cssClasses = {
            root: 'form-group',
            input: 'Demo__search-input',
            autocompleteContainer: 'Demo__autocomplete-container',
        }
        const AutocompleteItem = ({ formattedSuggestion }) => (
            <div className="Demo__suggestion-item">
                <i className='fa fa-map-marker Demo__suggestion-icon' />
                <strong>{formattedSuggestion.mainText}</strong>{' '}
                <small className="text-muted">{formattedSuggestion.secondaryText}</small>
            </div>
        )
        const inputProps = {
            type: "text",
            value: this.state.address,
            onChange: this.handleChange,
            autoFocus: true,
            placeholder: "Search Places",
            name: 'Demo__input',
            id: "address_map",
        }

        return (
            (this.state.isLoaded) ? <div className="general_setting">
                <div className="header">
                    <p>General setting</p>
                </div>
                <div className="detail">
                    <div className="spa-info">
                        <div className="left">
                            <TextInput
                                name="firstName"
                                label="First Name"
                                value={(firstName) ? firstName : ""}
                                showLabel={true}
                                // validations={validationData.firstName}
                                onChange={(value) => this.setState({
                                    firstName: value
                                })}
                            />
                            <TextInput
                                name="lastName"
                                label="Last Name"
                                value={(lastName) ? lastName : ""}
                                showLabel={true}
                                // validations={validationData.firstName}
                                onChange={(value) => this.setState({
                                    lastName: value
                                })}
                            />
                            <TextInput
                                name="businessName"
                                label="Business name"
                                value={(businessName) ? businessName : ""}
                                showLabel={true}
                                validations={validationData.businessName}
                                onChange={(value) => this.onTitleChange(value)}
                            />
                            <div className="business_name_slug">
                                <span>Slug</span>
                                <i> {this.state.slug}</i>
                            </div>
                        </div>
                        <div className="avatar">
                            <label>Logo</label>
                            <div className="avatar_image"
                                style={
                                    {
                                        backgroundImage: "url(" + ((logo === "") ? require('../../../assets/images/loader.gif') : logo) + ")",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        backgroundSize: "cover"
                                    }}>
                                <i className="fas fa-edit" onClick={() => this.setState({ isShowPopup: true })}></i>
                            </div>
                            {
                                (isShowPopup) ? <div className="upload-popup">
                                    <div className="popup-content">
                                        <div className="content-header">
                                            <span className="title">Change your avatar</span>
                                            <i className="fas fa-times" onClick={() => this.setState({ isShowPopup: false })}></i>
                                        </div>
                                        <div className="form-group info">
                                            <label>Photo <span className="text-danger">*</span></label>
                                            <FileDropZone
                                                base64Code={logo}
                                                onAdd={this.onAddLogo.bind(this)}
                                                onRemove={() => this.onRemoveLogo()} />
                                            <span className={"text-danger"} id={"validator-for-photo"}></span>
                                        </div>
                                    </div>
                                </div> : ""
                            }
                        </div>
                    </div>
                    {
                        (addressLoaded) ? <div className='address_container form-group info'>
                            <label>Business address</label>
                            {/* <p id="final_address_1">{((address) ? (address + ", ") : "") + ((cityValue) ? (cityValue + ", ") : "") + ((stateValue) ? (stateValue + ", ") : "") + ((countryValue) ? (countryValue) : "")}</p> */}
                            <div style={{ paddingLeft: "20px", borderLeft: "2px solid #d9c7fc", marginTop: "10px", paddingBottom: "10px" }}>
                                < div style={{ marginBottom: "10px" }}>
                                    <label className="header_logo">Address Line 1:</label>
                                    <input className="address_1" placeholder="Type your address" value={address} onChange={(e) => this.setState({ address: e.target.value })} />
                                </div>
                                < div style={{ marginBottom: "10px" }}>
                                    <label className="header_logo">Address Line 2:</label>
                                    <input className="address_2" placeholder="Type your address" value={address2} onChange={(e) => this.setState({ address2: e.target.value })} />
                                </div>
                                <div className="custom_address">
                                    <label className="header_logo">Your city:</label>
                                    <input className="city" placeholder="Type your address" value={cityValue} onChange={(e) => this.setState({ cityValue: e.target.value })} />
                                </div>
                                <div className="custom_address">
                                    <label className="header_logo">Your state:</label>
                                    <div className="section" style={{ marginBottom: "10px" }}>
                                        <VirtualizedSelect ref="stateSelect"
                                            options={states}
                                            simpleValue
                                            clearable
                                            name="select-state"
                                            value={stateValue}
                                            onChange={(value) => { this.setState({ stateValue: value }) }}
                                            searchable
                                            labelKey="name"
                                            valueKey="name"
                                        />
                                    </div>
                                </div>
                                <div className="custom_address">
                                    <label className="header_logo">Your country:</label>
                                    <div className="section" style={{ marginBottom: "10px" }}>
                                        <VirtualizedSelect ref="countrySelect"
                                            options={countrys}
                                            simpleValue
                                            clearable
                                            name="select-country"
                                            value={countryValue}
                                            onChange={(value) => { this.setState({ countryValue: value }) }}
                                            searchable
                                            labelKey="name"
                                            valueKey="name"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> : <div>
                                <label>Business address</label>
                                <div id="loading"></div>
                            </div>
                    }
                    <div className="zip_code">
                        <TextInput
                            name="zipCode"
                            label="ZipCode"
                            value={(zipCode) ? zipCode : ""}
                            showLabel={true}
                            validations={validationData.zipCode}
                            onChange={(value) => this.setState({
                                zipCode: value
                            })}
                        />
                    </div>
                    <div className="business_contact">
                        <TextInput
                            name="businessWebsite"
                            label="Website"
                            value={(businessWebsite) ? businessWebsite : ""}
                            showLabel={true}
                            validations={validationData.businessWebsite}
                            onChange={(value) => this.setState({
                                businessWebsite: value
                            })}
                        />
                        <br />
                        <TextInput
                            name="businessPhone"
                            label="Phone number"
                            value={(businessPhone) ? businessPhone : ""}
                            showLabel={true}
                            validations={validationData.businessPhone}
                            onChange={(value) => this.setState({
                                businessPhone: value
                            })}
                        />
                    </div>
                    <div className="form-group info business-link">
                        <div className="link-header">
                            <span className="title">Business Link</span>
                            <i className="fa fa-pencil-square-o" data-toggle="collapse" data-target="#link-edit" aria-hidden="true" onClick={() => $("#link-edit").toggleClass("expand")}></i>
                        </div>
                        <div className="link-icon">
                            <span className="facebook"><NavLink to={(this.state.businessFacebook) ? this.state.businessFacebook : "#"} target="_blank"><i className="fa fa-facebook" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Facebook</NavLink></span>
                            <span className="pinterest"><NavLink to={(this.state.businessPinterest) ? this.state.businessPinterest : "#"} target="_blank"><i className="fa fa-pinterest-p" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Pinterest</NavLink></span>
                            <span className="twitter"><NavLink to={(this.state.businessTwitter) ? this.state.businessTwitter : "#"} target="_blank"><i className="fa fa-twitter" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Twitter</NavLink></span>
                            <span className="instagram"><NavLink to={(this.state.businessInstagram) ? this.state.businessInstagram : "#"} target="_blank"><i className="fa fa-instagram" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Instagram</NavLink></span>
                            <span className="youtube"><NavLink to={(this.state.businessVideo) ? this.state.businessVideo : "#"} target="_blank"><i className="fa fa-youtube-play" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Youtube</NavLink></span>
                        </div>
                        <div className="link-edit collapse" id="link-edit">
                            <TextInput
                                name="businessFacebook"
                                label="Facebook link"
                                value={(businessFacebook) ? businessFacebook : ""}
                                showLabel={true}
                                validations={validationData.businessFacebook}
                                onChange={(value) => this.setState({
                                    businessFacebook: value
                                })}
                            />
                            <TextInput
                                name="businessPinterest"
                                label="Pinterest link"
                                value={(businessPinterest) ? businessPinterest : ""}
                                showLabel={true}
                                validations={validationData.businessPinterest}
                                onChange={(value) => this.setState({
                                    businessPinterest: value
                                })}
                            />
                            <TextInput
                                name="businessTwitter"
                                label="Twitter link"
                                value={(businessTwitter) ? businessTwitter : ""}
                                showLabel={true}
                                validations={validationData.businessTwitter}
                                onChange={(value) => this.setState({
                                    businessTwitter: value
                                })}
                            />
                            <TextInput
                                name="businessInstagram"
                                label="Instagram link"
                                value={(businessInstagram) ? businessInstagram : ""}
                                showLabel={true}
                                validations={validationData.businessInstagram}
                                onChange={(value) => this.setState({
                                    businessInstagram: value
                                })}
                            />
                            <TextInput
                                name="businessVideo"
                                label="Youtube link"
                                value={(businessVideo) ? businessVideo : ""}
                                showLabel={true}
                                validations={validationData.businessVideo}
                                onChange={(value) => this.setState({
                                    businessVideo: value
                                })}
                            />
                        </div>
                    </div>
                    {/* <div className="form-group info">
                        <label>Intro <span className="text-danger">*</span></label>
                        <textarea value={(businessIntro) ? businessIntro : ""} className="intro" onChange={(value) => this.onIntroChange(value)}></textarea>
                        <p id="intro_validation" className="text-danger"></p>
                    </div> */}
                    <div className="form-group info">
                        <label>About <span className="text-danger">*</span></label>
                        <textarea value={(businessAboutUs) ? businessAboutUs : ""} className="about_us" onChange={(value) => this.onAboutUsChange(value)}></textarea>
                        <p id="about_us_validation" className="text-danger"></p>
                    </div>
                    <div className="form-group info">
                        <label>Photo <span className="text-danger">*</span></label>
                        <FileDropZone
                            domainUrl={configs.api_domain}
                            initFiles={photos}
                            onAdd={this.onAddPhoto.bind(this)}
                            onRemove={this.onRemovePhoto.bind(this)} />
                        <span className={"text-danger"} id={"validator-for-photo"}></span>
                    </div>
                    <div className="form-group info submit">
                        <button className="save" id="save" onClick={this.handleUpdate.bind(this)}>Save</button>
                    </div>
                </div>
            </div> : <div>
                    <div className="spinner">
                        <div className="rect1"></div>
                        <div className="rect2"></div>
                        <div className="rect3"></div>
                        <div className="rect4"></div>
                        <div className="rect5"></div>
                    </div>
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partner/general/index.js